import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white snap-start">
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 py-8 sm:py-10">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <h3 className="text-xl font-bold mb-3">ViSRUPT</h3>
            <p className="text-slate-400 text-base">Registered MSME under the Government of India.</p>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-400 hover:text-white text-base">About Us</Link></li>
              <li><Link to="/divisions" className="text-slate-400 hover:text-white text-base">Our Divisions</Link></li>
              <li><Link to="/careers" className="text-slate-400 hover:text-white text-base">Careers</Link></li>
              <li><Link to="/faq" className="text-slate-400 hover:text-white text-base">FAQ</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white text-base">Contact</Link></li>
            </ul>
          </div>

          {/* Legal Documents */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold mb-3">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-slate-400 hover:text-white text-base">Terms of Service</Link></li>
              <li><Link to="/risk-disclosure" className="text-slate-400 hover:text-white text-base">Risk Disclosure</Link></li>
              <li><Link to="/privacy-policy" className="text-slate-400 hover:text-white text-base">Privacy & Confidentiality Policy</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold mb-3">Contact Info</h4>
            <ul className="space-y-2 text-slate-400 text-base">
              <li>
                <a 
                  href="tel:+917522979568" 
                  className="hover:text-white transition"
                >
                  Phone: +91 7522979568
                </a>
              </li>
              <li>
                <a 
                  href="mailto:support@visrupt.in" 
                  className="hover:text-white transition"
                >
                  Email: support@visrupt.in
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="text-center sm:text-left">
            <h4 className="text-lg font-semibold mb-3">Connect with Us</h4>
            <div className="flex justify-center sm:justify-start space-x-6">
              <a 
                href="https://www.linkedin.com/company/visrupt/about/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-white transition"
              >
                <Linkedin className="w-6 h-6" />
              </a>
              <a 
                href="https://api.whatsapp.com/send/?phone=%2B917522979568&text=Hey ViSRUPT,%20Can%20you%20build%20an%20Trading%20Algo%20for%20me?&app_absent=0" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-white transition"
              >
                <svg 
                  viewBox="0 0 24 24" 
                  fill="currentColor" 
                  className="w-6 h-6"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
              <a 
                href="mailto:support@visrupt.in" 
                className="text-slate-400 hover:text-white transition"
              >
                <Mail className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-800 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} ViSRUPT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;